import { FormArray, FormControl, FormGroup } from '@angular/forms';

export type SubmitPatchFn<
  T extends FormGroup | FormArray | FormControl,
  V,
  P = any,
> = (group: T, value: V) => P;
export const SUBMIT_PATCHES = Symbol('Patch submit values');

export function registerSubmitPatch<
  T extends FormGroup | FormArray | FormControl,
  V = T extends FormGroup ? Record<string | symbol | number, any> : any[],
>(group: T, patch: SubmitPatchFn<T, V>) {
  const arr = getSubmitPatches(group);
  arr.push(patch);
  Reflect.defineMetadata(SUBMIT_PATCHES, arr, group);
}

export function getSubmitPatches<T extends FormGroup | FormArray | FormControl>(
  group: T,
): SubmitPatchFn<T, any>[] {
  return Reflect.getMetadata(SUBMIT_PATCHES, group) ?? [];
}

export function resolveSubmitPatches(
  form: FormGroup | FormArray | FormControl,
  value: any,
  fieldPath = '',
) {
  if ('controls' in form) {
    for (const key of Object.keys(form.controls)) {
      const control = form.get(key);
      const newPath = fieldPath ? `${fieldPath}.${key}` : key;
      const deeperValue = value[key];

      if (
        (control instanceof FormGroup &&
          typeof deeperValue === 'object' &&
          deeperValue !== null) ||
        (control instanceof FormArray && Array.isArray(deeperValue))
      ) {
        value[key] = resolveSubmitPatches(control, deeperValue, newPath);
      }
    }
  }
  const patches = getSubmitPatches(form);
  try {
    return patches.reduce((value, fn) => fn(form, value), value);
  } catch (e) {
    throw new Error(`Error patching submit value for '${fieldPath}'`, {
      cause: e,
    });
  }
}
